import React, { Component } from "react";
import { withRouter } from '../../common/with-router';
import {Card} from "react-bootstrap";

class SemPermissao extends Component {
    render() {
        return (
            <div>
                <h4 className="page-title">Sem Permissão</h4>
                <Card border="light">
                    <Card.Body>                    
                        <p className="mt-3">Você não tem permissão para acessar essa página, contate o administrador.</p>                 
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(SemPermissao);